/** Slugs for nav when API is loading or failed (aligned with static home cards). */
export const HEADER_CATEGORY_FALLBACK = [
  { id: 1, name: "Football", slug: "football", status: 1 },
  { id: 2, name: "Basketball", slug: "basketball", status: 1 },
  { id: 3, name: "Cricket", slug: "cricket", status: 1 },
  { id: 4, name: "Hockey", slug: "hockey", status: 1 }
];

/**
 * Same buckets as Home: "Choose Your Sport" (row 1) vs "More Sports" (row 2).
 * @param {Array} categories - from GET /api/categories
 * @param {boolean} loading - while first fetch in flight
 * @param {Array} [staticFallback] - shape like Home CATEGORIES when loading or API fail
 */
export function categoriesForHomeRow1(categories, loading, staticFallback = []) {
  if (loading && staticFallback.length > 0) {
    return staticFallback.filter(
      (c) => !c.display_location || c.display_location === "home_row_1"
    );
  }
  return categories.filter(
    (c) =>
      (c.display_location === "home_row_1" ||
        (!c.display_location && c.status !== 0)) &&
      c.status !== 0
  );
}

export function categoriesForHomeRow2(categories, loading) {
  if (loading) return [];
  return categories.filter(
    (c) => c.display_location === "home_row_2" && c.status !== 0
  );
}
